import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { PAY_URL } from '../../../BaseURL';
import axios from 'axios';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import Loader from '../include/Loader';

import { Pagination, Search } from '../Table';
import { Modal } from 'react-bootstrap';
import Header from '../include/Header';
import Sidebar from '../include/Sidebar';
import moment from 'moment';
import DropDonwlLimit from '../Components/DropDonwlLimit';
import ProcessLoader from '../Components/ProcessLoader';
const PartyBill = () => {
  const navigate = useNavigate();
  const [bills, setBills] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  // const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(true);
    const [limit, setlimit] = useState(10);
 const [disable, setDisable] = useState(true);
    const [loader, setLoader] = useState(false);
  const [modalData, setModalData] = useState({ remark: '', otherRemark: '' });
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('PAY_ADMIN_TOKEN')) {
      navigate('/admin/login');
    } else {
      fetchPartyBills();
    }
  }, [navigate]);

//   const fetchPartyBills = () => {
//     setLoading(true);
//     axios
//       .get(`${PAY_URL}/user/get-party-bill`, {
//         headers: { Authorization: 'Bearer ' + localStorage.getItem('PAY_ADMIN_TOKEN') },
//       })

      
//       .then((res) => {
//         if (res.data.success) {
//           setBills(res.data.data);
//         } else {
//           toast.error(res.data.message || 'Failed to fetch party bills');
//         }
//       })
//       .catch(() => toast.error('Server error'))
//       .finally(() => setLoading(false));
//   };

const fetchPartyBills = (page = 1, limit = 10, searchTerm = '') => {
  setLoading(true);
  axios
    .get(`${PAY_URL}/user/get-party-bill`, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('PAY_ADMIN_TOKEN') },
      params: { page, limit, search: searchTerm } // send search
    })
    .then((res) => {
      if (res.data.success) {
        setBills(res.data.data);          
        setTotalItems(res.data.pagination.total); 
      } else {
        toast.error(res.data.message || 'Failed to fetch party bills');
      }
    })
    .catch(() => toast.error('Server error'))
    .finally(() => setLoading(false));
};

// Trigger search
const handleSearch = (val) => {
  setSearch(val);
  setCurrentPage(1);
  fetchPartyBills(1, limit, val);
};

 const handleRefresh = () => {
        setSearch("");
        setCurrentPage(1);
        setlimit(10);
        setDisable(true);
        setLoader(false);
       
    }

// const handleDownload = async () => {
//   setLoader(true);

//   try {
//     const myurl = `${PAY_URL}/user/party-bill-export-excel-download`;

//     const bodyFormData = new URLSearchParams();
//     // bodyFormData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
//     bodyFormData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
//     bodyFormData.append('print_date', true);

//     const response = await axios({
//       method: "post",
//       url: myurl,
//       data: bodyFormData,
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//         Authorization: "Bearer " + localStorage.getItem('PAY_ADMIN_TOKEN'),
//       },
//       responseType: 'blob',
//     });

//     //  Create and name the download file
//     const blob = new Blob([response.data], {
//       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//     });
//     const link = document.createElement('a');
//     link.href = URL.createObjectURL(blob);
//     link.download = "BILL RECEIVED DETAILS 2025-26.xlsx"; // fixed name
//     document.body.appendChild(link);
//     link.click();
//     // document.body.removeChild(link);

//     toast.success("Party Bill Excel downloaded successfully");
//   } catch (error) {
//     console.error(error);
//     toast.error(error?.response?.data?.message || "Download failed");
//   } finally {
//     setLoader(false);
//   }
// };

const handleDownload = async () => {
  try {
    setLoader(true);
    const response = await axios.post(`${PAY_URL}/user/party-bill-export-excel-download`, {
      year_id: localStorage.getItem('PAY_USER_YEAR_ID'),
      print_date: true,
    }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem('PAY_ADMIN_TOKEN'),
      }
    });

    const fileUrl = response.data.data.fileUrl;
    window.open(fileUrl, "_blank"); // Open/download in new tab
    toast.success("Party Bill Excel ready to download");
  } catch (err) {
    toast.error(err?.response?.data?.message || "Download failed");
  } finally {
    setLoader(false);
  }
};

useEffect(() => {
  if (!localStorage.getItem('PAY_ADMIN_TOKEN')) {
    navigate('/admin/login');
  } else {
    fetchPartyBills(currentPage, limit, search);
  }
}, [navigate, currentPage, limit, search]);

// Remove frontend slicing and use the bills directly
const displayedBills = useMemo(() => bills, [bills]);

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure you want to delete this Party Bill?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${PAY_URL}/admin/delete-party-bill/${id}/delete-party-bill`, {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('PAY_ADMIN_TOKEN') },
          })
          .then((res) => {
            if (res.data.success) {
              toast.success(res.data.message);
              fetchPartyBills();
            } else {
              toast.error(res.data.message || 'Failed to delete');
            }
          })
          .catch(() => toast.error('Server error'));
      }
    });
  };

 



  // Filtered & paginated bills
//   const displayedBills = useMemo(() => {
//     let filtered = bills;
//     if (search) {
//       filtered = filtered.filter(
//         (b) =>
//           b.party_id?.name?.toLowerCase().includes(search.toLowerCase()) ||
//           b.project_id?.name?.toLowerCase().includes(search.toLowerCase()) ||
//           b.po_no?.toLowerCase().includes(search.toLowerCase())
//       );
//     }
//     setTotalItems(filtered.length);
//     return filtered.slice((currentPage - 1) * limit, currentPage * limit);
//   }, [bills, search, currentPage, limit]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title admin-title">Party Bill Management</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/admin/dashboard">Dashboard</Link></li>
                  <li className="breadcrumb-item active">Party Bills</li>
                </ul>
              </div>
              <div className="col-auto float-end ms-auto">
                <Link to="/admin/manage-party-bill" className="btn btn-success">
                  <i className="fa-solid fa-plus"></i> Add Party Bill
                </Link>
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-4">
              {/* <Search onSearch={(val) => { setSearch(val); setCurrentPage(1); }} /> */}
                <Search onSearch={handleSearch} />
            </div>


            
  <div className="col-sm-12 col-md-8">
                            <div className="row justify-content-end">
                                <div className="col-md-12 mb-2">
                                    <div className="justify-content-end d-flex align-center flex-wrap gap-2">
                                        <div className="seletePage d-flex gap-2 align-items-center ">
                                            <p className="mb-0">Rows per page:</p>
                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                <DropDonwlLimit limit={limit} onLimitChange={(val) => setlimit(val)} />
                                                <div className="refreshPage">
                                                    <button className="btn btn-refresh" type='butotn' onClick={handleRefresh}>
                                                        <i className="fa-solid fa-arrows-rotate"></i>
                                                    </button>
                                                </div>
                                                <div className="refreshPage">
                                                    <button className="btn btn-refresh" type='button' onClick={handleDownload}>
                                                        {loading ? <ProcessLoader /> : <i className="fa-solid fa-download"></i>}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
          </div>


          {loading ? (
            <Loader />
          ) : (
            <div className="card p-3">
              <div className="table-responsive">
                <table className="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>Project</th>
                      <th>Party</th>
                      <th>PO No</th>
                      <th>Firm</th>
                      <th>Invoice No</th>
                       <th>Invoice Date</th>
                    <th>Receiving By</th>
                        <th>Receiving From</th>
                        <th>Receiving Date</th>
                         <th>Category</th>
                          <th>Description</th>
                      <th>Amount without GST</th>               
                      <th>CGST</th>
                      <th>SGST</th>
                      <th>IGST</th>
                    <th>Amount with GST</th>
                     <th>Bank Name</th>
                      <th>Account No</th>
                       <th>IFSC Code</th>
                        <th>Balance Amount</th>
                      <th>Mail Status</th>
                      <th>Payment Status</th>
                      <th>Remarks</th>
                     
                      <th className="text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedBills.length > 0 ? (
                      displayedBills.map((bill, i) => (
                        <tr key={bill._id}>
                          <td>{(currentPage - 1) * limit + i + 1}</td>
                          <td>{bill.project_id?.name || '-'}</td>
                          <td>{bill.party_id?.name || '-'}</td>
                          <td>{bill.po_no || '-'}</td> 
                          <td>{bill.firm_id?.name || '-'}</td>                       
                          <td>{bill.invoice_no || '-'}</td>
                          <td>{bill.invoice_date || '-'}</td>
                          <td>{bill.receiving_by || '-'}</td>                          
                          <td>{bill.receiving_from || '-'}</td>
                          <td>{bill.receiving_date || '-'}</td>
                          <td>{bill.category || '-'}</td>
                          <td>{bill.description || '-'}</td>
                          <td>{bill.amount_with_out_gst || '-'}</td>
                          <td>{bill.cgst || '-'}</td>
                          <td>{bill.sgst || '-'}</td>
                          <td>{bill.igst || '-'}</td>
                          <td>{bill.amount_with_gst || '-'}</td>
                           <td>{bill.party_id?.bank_name || '-'}</td>
                           
                            <td>{bill.party_id?.bank_acc_no || '-'}</td>
                             <td>{bill.party_id?.ifsc_code || '-'}</td>
                            <td>{bill.balance_amount || '-'}</td>
                          
                        
                            <td>
                            {bill.mail_status ? (
                              <span className="badge text-bg-success">Sent</span>
                            ) : (
                              <span className="badge text-bg-warning">Pending</span>
                            )}
                          </td>
                          <td>
                            {bill.payment_status ? (
                              <span className="badge text-bg-success">Paid</span>
                            ) : (
                              <span className="badge text-bg-warning">Pending</span>
                            )}
                          </td>

                            <td>{bill.remark || '-'}</td>
                          <td className="text-end">
                            <div className="dropdown dropdown-action">
                              <a href="#" className="action-icon dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="material-icons">more_vert</i>
                              </a>
                              <div className="dropdown-menu dropdown-menu-right">
                                <button className="dropdown-item" onClick={() => navigate('/admin/manage-party-bill', { state: bill })}>
                                  <i className="fa-solid fa-pencil m-r-5"></i> Edit
                                </button>
                                <button className="dropdown-item" onClick={() => handleDelete(bill._id)}>
                                  <i className="fa-regular fa-trash-can m-r-5"></i> Delete
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="13" className="text-center">No Party Bills Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <div>Showing {Math.min(limit, totalItems)} of {totalItems} entries</div>
                <Pagination total={totalItems} itemsPerPage={limit} currentPage={currentPage} onPageChange={setCurrentPage} />
              </div>
            </div>
          )}

          

          {/* Remark Modal */}
         
        </div>
      </div>
    </div>
  );
};

export default PartyBill;
